<template>
  <div class='animated fadeIn'>
    <div class='container'>
      <b-card class='shadow-sm p-3 mb-2 bg-white rounded' title='プライバシーポリシー'>
        <b-card-header header-bg-variant='white'>
          <a href='http://freewill.education'>（株）Freewill トータルエデュケーション</a>（以下，「当社」といいます。）は，本ウェブサイト上で提供するサービス（以下,「本サービス」といいます。）におけるプライバシー情報の取扱いについて，以下のとおりプライバシーポリシー（以下，「本ポリシー」といいます。）を定めます。
        </b-card-header>
            <b-list-group flush>
              <b-list-group-item>
第1条【プライバシー情報】<br>
1．プライバシー情報のうち「個人情報」とは，個人情報保護法にいう「個人情報」を指すものとし，生存する個人に関する情報であって，当該情報に含まれる氏名，生年月日，連絡先その他の記述等により特定の個人を識別できる情報を指します。<br>
2．プライバシー情報のうち「履歴情報および特性情報」とは，上記に定める「個人情報」以外のものをいい，ご利用いただいたサービスや，ご覧になったページや広告の履歴，ユーザーが検索された検索キーワード，ご利用日時，ご利用の方法，ご利用環境，年齢，ユーザーのIPアドレス，クッキー情報，位置情報，端末の個体識別情報などを指します。<br>
<br>
第2条【プライバシー情報の収集方法】<br>
1. 当社は，ユーザーが利用登録をする際に氏名，生年月日，メールアドレス，などの個人情報をお尋ねすることがあります。<br>
2. 当社は，ユーザーについて，利用したサービスやソフトウエア，閲覧したページや広告の履歴，検索した検索キーワード，利用日時，利用方法，利用環境（携帯端末を通じてご利用の場合の当該端末の通信状態，利用に際しての各種設定情報なども含みます），IPアドレス，クッキー情報，位置情報，端末の個体識別情報などの履歴情報および特性情報を，ユーザーが当社のサービスを利用しまたはページを閲覧する際に収集します。<br>
<br>
第3条【個人情報を収集・利用する目的】<br>
1. 当社が個人情報を収集・利用する目的は，以下のとおりです。<br>
（1）ユーザーに自分の登録情報の閲覧や修正，利用状況の閲覧を行っていただくために，氏名，などの登録情報，利用されたサービスに関する情報を表示する目的<br>
（2）ユーザーにお知らせや連絡をするためにメールアドレスを利用するする目的<br>
（3）ユーザーの本人確認を行うために，氏名，生年月日，などの情報を表示する目的<br>
（4）ユーザーが簡便にデータを入力できるようにするために，当社に登録されている情報を入力画面に表示させたり，ユーザーのご指示に基づいて他のサービスなど（提携先が提供するものも含みます）に転送したりする目的<br>
（5）第三者に損害を発生させたりするなど，本サービスの利用規約に違反したユーザーや，不正・不当な目的でサービスを利用しようとするユーザーの利用をお断りするために，利用態様，氏名など個人を特定するための情報を利用する目的<br>
（6）ユーザーからのお問い合わせに対応するために，お問い合わせ内容や当社がユーザーに対してサービスを提供するにあたって必要となる情報や，ユーザーのサービス利用状況，連絡先情報などを利用する目的<br>
（7）上記の利用目的に付随する目的<br>
<br>
第4条【個人情報の第三者提供】<br>
1. 当社は，次に掲げる場合を除いて，あらかじめユーザーの同意を得ることなく，第三者に個人情報を提供することはありません。ただし，個人情報保護法その他の法令で認められる場合を除きます。<br>
（1）法令に基づく場合<br>
（2）人の生命，身体または財産の保護のために必要がある場合であって，本人の同意を得ることが困難であるとき<br>
（3）公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって，本人の同意を得ることが困難であるとき<br>
（4）国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって，本人の同意を得ることにより・当該事務の遂行に支障を及ぼすおそれがあるとき<br>
（5）予め次の事項を告知あるいは公表をしている場合<br>
・利用目的に第三者への提供を含むこと<br>
・第三者に提供されるデータの項目<br>
・第三者への提供の手段または方法<br>
・本人の求めに応じて個人情報の第三者への提供を停止すること<br>
<br>
2. 前項の定めにかかわらず，次に掲げる場合は第三者には該当しないものとします。<br>
（1）当社が利用目的の達成に必要な範囲内において個人情報の取扱いの全部または一部を委託する場合<br>
（2）合併その他の事由による事業の承継に伴って個人情報が提供される場合<br>
（3）個人情報を特定の者との間で共同して利用する場合であって，その旨並びに共同して利用される個人情報の項目，共同して利用する者の範囲，利用する者の利用目的および当該個人情報の管理について責任を有する者の氏名または名称について，あらかじめ本人に通知し，または本人が容易に知り得る状態に置いているとき<br>
<br>
第5条【個人情報の開示】<br>
1. 当社は，本人から個人情報の開示を求められたときは，本人に対し，遅滞なくこれを開示します。ただし，開示することにより次のいずれかに該当する場合は，その全部または一部を開示しないこともあり，開示しない決定をした場合には，その旨を遅滞なく通知します。なお，個人情報の開示に際しては，1件あたり 1,000円の手数料を申し受ける場合があります。<br>
（1）本人または第三者の生命，身体，財産その他の権利利益を害するおそれがある場合<br>
（2）当社の業務の適正な実施に著しい支障を及ぼすおそれがある場合<br>
（3）その他法令に違反することとなる場合<br>
2. 前項の定めにかかわらず，履歴情報および特性情報などの個人情報以外の情報については，原則として開示いたしません。<br>
<br>
第6条【個人情報の訂正および削除】<br>
1. ユーザーは，当社の保有する自己の個人情報が誤った情報である場合には，当社が定める手続きにより，当社に対して個人情報の訂正または削除を請求することができます。<br>
2. 当社は，ユーザーから前項の請求を受けてその請求に応じる必要があると判断した場合には，遅滞なく，当該個人情報の訂正または削除を行い，これをユーザーに通知します。<br>
<br>
第7条【個人情報の利用停止等】<br>
当社は，本人から，個人情報が，利用目的の範囲を超えて取り扱われているという理由，または不正の手段により取得されたものであるという理由により，その利用の停止または消去（以下，「利用停止等」といいます。）を求められた場合には，遅滞なく必要な調査を行い，その結果に基づき，個人情報の利用停止等を行い，その旨本人に通知します。ただし，個人情報の利用停止等に多額の費用を有する場合その他利用停止等を行うことが困難な場合であって，本人の権利利益を保護するために必要なこれに代わるべき措置をとれる場合は，この代替策を講じます。<br>
<br>
第8条【プライバシーポリシーの変更】<br>
1. 本ポリシーの内容は，ユーザーに通知することなく，変更することができるものとします。<br>
2. 当社が別途定める場合を除いて，変更後のプライバシーポリシーは，本ウェブサイトに掲載したときから効力を生じるものとします。<br>
<br>
第9条【お問い合わせ窓口】<br>
本ポリシーに関するお問い合わせは，以下にお願いいたします。<br>
<br>
住所：〒150-0022 東京都渋谷区恵比寿南2-24-9 Tel：03-3760-0291（代表）<br>
担当：柴山 健太郎<br>
<br>
以上<br>
<br>
（附則）<br>
本ポリシーは、2018年9月23日より施行致します。<br>
<br>
2018年09月23日制定<br>
            </b-list-group-item>
          </b-list-group>
        <b-card-footer footer-bg-variant='white'>
          <b-button @click='goBack'>Back</b-button>
        </b-card-footer>
      </b-card>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Privacy',
  methods: {
    goBack () {
      this.$router.go(-1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Privacy.vue